import { call } from 'redux-saga/effects';
import { getCookie, getQueryParam, requestJson, RequestResponse } from '@vfde-sails/utils';
import { Cookies, Domains, Endpoints, QueryNames } from '../../enum';
import { getUrl } from '../../util/url';
import { ValidateTokenRequest, ValidateTokenResponse } from './interface';
import { isStagingEnv } from '../../util/jarvisHelpers';

export function* getFFToken () {
    const queryToken: string | null = yield call(getQueryParam, QueryNames.FRIENDS_AND_FAMILY);

    if (queryToken) {
        return queryToken;
    }

    const cookieToken: string | null = yield call(getCookie, Cookies.FRIENDS_AND_FAMILY);

    if (cookieToken) {
        return cookieToken;
    }

    return null;
}

export function* postValidateToken (token: string) {
    const url: string = isStagingEnv() ? yield call(getUrl, Domains.ST, Endpoints.FRIENDS_AND_FAMILY) : yield call(getUrl, Domains.ZUHAUSEPLUS, Endpoints.FRIENDS_AND_FAMILY);
    const body: ValidateTokenRequest = {
        ffv2: token,
    };
    const options: RequestInit = {
        headers: [['Content-Type', 'application/json']],
        method: 'POST',
        body: yield call(JSON.stringify, body),
    };

    const response: RequestResponse<ValidateTokenResponse> = yield call(requestJson, url, options);

    return response.body;
}
